import OMOSettingsLayout from "../layout/OMOSettingsLayout";
import OMOPlayLogo from "../../assets/images/omoplay_logo_black.svg";
import {Button} from "omoplay";
import {logout} from "../../api/account/account.api";
import OMOConnectImage from "../../assets/images/omo_connect_image.png";
import SimpleScreen from "../../assets/images/simple_screen.png";
import {useRecoilValue} from "recoil";
import {accountSelector} from "../../store/selector/selector";

const ChannelChoicePage = () => {
    const account = useRecoilValue(accountSelector);
    // account 는 `GET /account` 실패 시 `{}` 다. 무방비로 인덱싱하면 렌더 중 TypeError →
    // ErrorBoundary 가 없어 앱 전체가 흰 화면이 된다(2026-09-14). `Layout.js` 상단 주석 참고.
    const channel = account?.channels?.[0]

    return (
        <OMOSettingsLayout title="채널 선택">
            <div>
                <div className="items-center">
                    <div className="flex-col gap-[32px] border bg-white p-[32px]" style={{width: "1280px", borderRadius: "16px"}}>
                        <div className="flex justify-between">
                            <div className="w-[200px]">
                                <img alt="" src={OMOPlayLogo} />
                            </div>
                            <div>
                                <Button variants="secondary" value="로그아웃" onClick={() => logout()} />
                            </div>
                        </div>
                        <div className="text-[28px] font-bold mb-8"> {/* mb-8로 간격 추가 */}
                            환영합니다! 신청할 서비스를 선택하세요<br/>
                        </div>

                        <div className="flex gap-8 slide-up justify-center">

                            {/* 첫 번째 카드: OMO Connect */}
                            <div
                                className="group flex-1 cursor-pointer rounded-2xl border border-gray-200 bg-white p-6 transition-all duration-300 hover:-translate-y-2 hover:border-blue-500 hover:shadow-2xl"
                                onClick={() => window.location.href = `/settings/connect?id=${channel.id}`}
                            >
                                <div className="overflow-hidden rounded-xl bg-gray-50 border border-gray-100">
                                    <img src={OMOConnectImage} alt="omo-connect" className="w-full object-cover"/>
                                </div>
                                <div className="mt-6 text-center">
                                    <div className="text-[24px] font-bold text-gray-900">오모Connect</div>
                                    <div className="text-[16px] text-gray-500 mt-2 font-medium">(100% 회원 전환 서비스)</div>

                                    {/* 신청 버튼 추가 */}
                                    <div className="mt-6">
                            <span className="inline-block w-full rounded-lg bg-blue-600 py-3 text-[18px] font-bold text-white transition-colors group-hover:bg-blue-700">
                                신청하러 가기
                            </span>
                                    </div>
                                </div>
                            </div>

                            {/* 두 번째 카드: 오모조인 */}
                            <div
                                className="group flex-1 cursor-pointer rounded-2xl border border-gray-200 bg-white p-6 transition-all duration-300 hover:-translate-y-2 hover:border-blue-500 hover:shadow-2xl"
                                onClick={() => window.location.href = `/settings/screen?id=${channel.id}`}
                            >
                                <div className="overflow-hidden rounded-xl bg-gray-50 border border-gray-100">
                                    <img src={SimpleScreen} alt="omo-join" className="w-full object-cover"/>
                                </div>
                                <div className="mt-6 text-center">
                                    <div className="text-[24px] font-bold text-gray-900">오모조인</div>
                                    <div className="text-[16px] text-gray-500 mt-2 font-medium">(간편 로그인)</div>

                                    {/* 신청 버튼 추가 */}
                                    <div className="mt-6">
                            <span className="inline-block w-full rounded-lg bg-blue-600 py-3 text-[18px] font-bold text-white transition-colors group-hover:bg-blue-700">
                                신청하러 가기
                            </span>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </OMOSettingsLayout>
    );
};
export default ChannelChoicePage;
